export class QuestionnaireAnswerRequest {
    RetentionQuestionnaireAnswerID: number | null;
    AccountID: number | null;
    QuestionNumber: number | null;
    RetentionAnswerOptionIDs: number[] | null;
    AnswerText: string | null;
    RetentionOfferTypeID?: number | null;
}